export const unityListAndCall = () => {
  (window as any)["list_and_call"] = async (sceneName: any, func: any) => {
    var result = await (window as any).listFiles(sceneName);
    func(result);
  };
};
